import Vue from 'vue';
import Rollbar from 'vue-rollbar';
import App from './App.vue';
import IconBase from '@/components/IconBase.vue';
import globalMixin from './mixins/global';
import router from './router/router';
import store from './store/store';
import Vuelidate from 'vuelidate';
import VueGtag from 'vue-gtag';
import Loading from 'vue-loading-overlay';
import Simplert from 'vue2-simplert-plugin';
import VueI18n from 'vue-i18n';
import VueTelInput from 'vue-tel-input';
import VueQrcodeReader from 'vue-qrcode-reader';

import { Plugin } from 'vue-fragment';
import { ALL_TRANSLATIONS } from './translations/all';

import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue2-simplert-plugin/dist/vue2-simplert-plugin.css';

require('@gouch/to-title-case');

Vue.config.productionTip = false;

Vue.use(Rollbar, {
  accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  source_map_enabled: process.env.VUE_APP_VERSION === '<APP_VERSION>' ? false : true,
  environment: process.env.VUE_APP_VERSION === '<APP_VERSION>' ? 'local' : process.env.NODE_ENV,
  payload: {
    client: {
      javascript: {
        code_version: process.env.VUE_APP_VERSION === '<APP_VERSION>' ? 'local' : process.env.VUE_APP_VERSION,
      },
    },
  },
});

Vue.use(VueQrcodeReader);
Vue.use(Vuelidate);
Vue.use(VueI18n);
Vue.use(Plugin);
Vue.use(VueTelInput);
Vue.use(Loading);
Vue.use(Simplert);
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_ID },
});

Vue.component('icon-base', IconBase);

Vue.mixin(globalMixin);

const i18n = new VueI18n({
  locale: 'en',
  messages: JSON.parse(JSON.stringify(ALL_TRANSLATIONS)),
});

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
